module.exports = __webpack_public_path__ + "static/media/mission.208efab8.svg";